import comp from "./DialogActionModal";
export default comp;
